import React, { Component } from 'react';
import arrow from '../../assets/images/icons/arrow-left.svg';
import { api_url, headers } from '../../common/config';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
class Research extends Component {
    constructor(props) {
        super(props);

        this.state = { image: '' };
    }

    componentDidMount() {
        this.getImage();
    }

    getImage = () => {
        if (this.props.image !== undefined) {
            fetch(`${api_url}/autism/files/${this.props.image}`, {
                method: 'GET',
                // headers: headers,
            })
                .then((res) => res.json())
                .then((res) => {
                    this.setState({
                        image: res.data.data.full_url,
                    });
                });
        }
    };

    render() {
        let time = this.props.time.split(' ');
        const { t, i18n } = this.props;
        return (
            <Link to={`/blog/research/${this.props.id}`} replace>
                <div className='articale_card'>
                    <div
                        className='card_image'
                        style={{
                            backgroundImage: `url(${this.state.image})`,
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'center',
                        }}
                    ></div>
                    <div className='card_content'>
                        <div className='wrapper'>
                            <p>{this.props.name}</p>
                            <p>{time[0]}</p>
                        </div>
                        <h2>{this.props.title}</h2>
                        <h3 style={{ height: '61%', overflow: 'hidden' }}>
                            {this.props.abstract}
                        </h3>
                        <a>
                            {t('keepReading')}
                            <img
                                src={arrow}
                                alt=''
                                className={`${
                                    i18n.language === 'en' ? 'flip' : ''
                                }`}
                            />
                        </a>
                    </div>
                </div>
            </Link>
        );
    }
}

export default withTranslation()(Research);
